<template>
  <div class="h-dialogContainer">
    <div class="row h-row-inputBox">
      <div class="col-sm-7 h-col-inputBox">
        <div class='h-inputLit'>
          <span>{{$t('MCS.groupNum')}}</span>
        </div>
        <input class="e-input" :value='groupid' disabled="true"/>
      </div>
      <!--<div class="col-sm-7 h-col-inputBox">-->
        <!--<div class='h-inputLit'>-->
          <!--<span>{{$t('MCS.groupAlias')}}</span>-->
        <!--</div>-->
        <!--<input class="e-input" :value='grpAlias' disabled="true"/>-->
      <!--</div>-->
    </div>
    <br>
    <div class="h-borderBox height-464">
      <div class="h-dialog-borderBox-topIcon" style="padding: 0px;">
        <input class="e-input" type="text" v-model='searchNum' style="width: 200px;margin:5px 5px 5px 15px">
        <button :title='$t("MCS.superSearch")' class="my-class e-btn e-tbar-btn icon hero-icon hero-icon-search" @click='searchGridData' data-ripple="true" tabindex="-1">
        </button>

        <button :title='$t("MCS.add")' class="my-class e-btn e-tbar-btn icon hero-icon hero-icon-add-small" data-ripple="true" tabindex="-1" @click='addGroupMember' style="margin: 5px 10px 5px 5px;float: right">
        </button>
      </div>
      <div class="h-borderBox-content" style="overflow: hidden">
        <ejs-grid ref='grid' :dataSource="data" height='100%' :allowReordering='true' :allowResizing='true'>
          <e-columns>
            <e-column type='checkbox' headerText='userNum' width='30' textAlign='Center'></e-column>
            <e-column field='userNum' clipMode='EllipsisWithTooltip' headerText='MC-ID' width='150' textAlign='Center'></e-column>
            <e-column field='userAlias' clipMode='EllipsisWithTooltip' :headerText='$t("MCS.userAlias")' width='150' textAlign='Center'></e-column>
            <e-column field='userType' clipMode='EllipsisWithTooltip' :valueAccessor='participantTypeFormatter' :headerText='$t("MCS.participantType")' width='150' textAlign='Center'></e-column>
          </e-columns>
        </ejs-grid>
      </div>
    </div>
    <div>
      <ejs-pager ref='pager' @click='getGridData()' :pageSize='page.pageSize' :currentPage='page.pageNo' :totalRecordsCount='page.totalCount' ></ejs-pager>
    </div>
    <CustomDialog ref='dialogPage' :element='dialogTip' :styles='styles'>
      <template v-slot:dialog-content>
        <DialogList ref='dialog' ></DialogList>
      </template>
    </CustomDialog>
  </div>
</template>

<script>

import commonJS from '../../common';
import CustomDialog from '../../../../common/CustomDialog';
import DialogList from '../../../../subscriberconfig/util/tipDialog/DialogList';

export default {
  name: 'AddGroupMemberDialog',
  mixins: [commonJS],
  props: [
    'neid',
    'vpnId',
    'vpnClass'
  ],
  components: {
    DialogList,
    CustomDialog
  },
  data() {
    return {
      data: {},
      groupid: '',
      grpAlias:'',
      page: {
        pageNo: 1,
        pageSize: 100,
        totalCount: 0,
        pageCount: 0,
      },
      searchNum: '',
      vo: {
        flag: '',
        participantType: ''
      },
      dialogTip: {
        target: this.$refs.grouptable,
        refName: 'dialogList',
        buttonGroup: [
          { click: this.closeDialogListTipPage, buttonModel: { content: this.$t('MCS.cancle') } }
        ],
        title: this.$t('MCS.messageInfo'),
        isClose: true,
      },
      neIdForQryUserInfo: undefined
    };
  },
  methods: {
    searchGridData(groupid = this.groupid, neid = this.neid) {
      const $this = this;
      if (groupid.movementX !== 0) {
        this.groupid = groupid;
      }
      const vo = {
        flag: 2,
        userNum: $this.searchNum,
        userType: 0,
        enterpriseDomain: $this.enterpriseDomain,
        productType: $this.productType,
        vpnId: 0,
        vpnClass: 0
      };
      if (this.neIdForQryUserInfo === undefined)
        this.neIdForQryUserInfo = neid;
      const params = {
        info: {
          neid: this.neIdForQryUserInfo,
          msgid: this.msg.qryUsers
        },
        vo: vo,
        page: {
          pageNo: 1,// 搜索默认返回第一页内容
          pageSize: this.page.pageSize
        }
      };
      this.$refs.pager.ej2Instances.goToPage(1);
      this.$axios.post(this.requestCommon, params).then((response) => {
        const res = response.data.resultVal;
        $this.data = res.result;
        $this.page.totalCount = res.totalCnt;
      });
    },

    getGridData(groupid = this.groupid, neid = this.neid) {
      const $this = this;
      if (groupid.movementX !== 0) {
        this.groupid = groupid;
        // this.grpAlias = grpAlias;
      }
      const vo = {
        flag: 2,
        userNum: $this.searchNum,
        userType: 0,
        enterpriseDomain: $this.enterpriseDomain,
        productType: $this.productType,
        vpnId: 0,
        vpnClass: 0
      };
      if (this.neIdForQryUserInfo === undefined)
        this.neIdForQryUserInfo = neid;
      const params = {
        info: {
          neid: this.neIdForQryUserInfo,
          msgid: this.msg.qryUsers
        },
        vo: vo,
        page: {
          pageNo: $this.$refs.pager.ej2Instances.currentPage,
          pageSize: this.page.pageSize
        }
      };
      this.$axios.post(this.requestCommon, params).then((response) => {
        const res = response.data.resultVal;
        $this.data = res.result;
        $this.page.totalCount = res.totalCnt;
      });
    },

    addGroupMember() {
      const $this = this;
      const selectedRecords = this.$refs.grid.getSelectedRecords();
      if (selectedRecords.length < 1) {
        this.$toast('warning', this.$t('Common.tips.noSelect'));
        return;
      }
      const userNum = [];
      selectedRecords.forEach((item) => {
        userNum.push(item.userNum);
      });
      const logArray = [];
      userNum.forEach((numItem) => {
        logArray.push({
          groupNum: $this.groupid,
          userNum: numItem
        });
      });
      const params = {
        info: {
          neid: this.neid,
          msgid: this.msg.addGroupMember,
        },
        vo: {
          enterpriseDomain: $this.enterpriseDomain,
          productType: $this.productType,
          groupId: $this.groupid,
          opCount: selectedRecords.length,
          userNum: userNum,
          userPriority: 1,
          userPrivilege: 0
        },
        log: {
          module: 'res.subscriber#res.subscriber_mcs#res.subscriber_mcs_group',
          execFunName: 'subscriber.addGroupMember',
          exectype: 1,
          execData: logArray
        }
      };
      this.$axios.post(this.requestCommon, params).then((response) => {
        $this.commonResp(response);
      });
    },
    closeDialogListTipPage() {
      this.$refs.dialogPage.clear();
      this.$refs.dialogPage.close();
    },
  },
};
</script>

<style scoped>
  .my-class.e-btn:active,.my-class.e-btn:focus{
    box-shadow: none !important;
  }

  .my-class{
    width: 30px;
    height: 30px;
    padding: 0px;
    color: #007bff;
    background-color: #e6f7ff;
    border: 0px;
  }
</style>
